import React from "react";
import clsx from "clsx";

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import {ArrowBack} from "@material-ui/icons";

import styles from "../styles";
import {renderQuestion as renderQuestionFunc} from "../../../../../utils";
import PrimaryButton from "../../../../../../../components/Buttons/PrimaryButton";
import StepFooter from "../../StepFooter";
import StepName from "./components/StepName";
import {SAVE_AND_CONTINUE_BTN_LABEL} from "../../../../../constants";
import InfoCard from "./components/InfoCard";
import ExtraTexts from "./components/ExtraTexts";

const DynamicStep = props => {
  const {
    classes,
    uid,
    name,
    questions,
    info_text,
    help_text,
    extra_texts,
    required,
    isFirst,
    onNextClick,
    onPrevClick,
    onGoToStepClick,
    onAnswerChange,
    custom_classes,
    dataService,
    StepContentComponent,
    extraRightButtons,
    leftAligned,
  } = props;

  const handleAnswerChange = (question, answer) => {
    onAnswerChange(question, answer);
  };

  const renderQuestion = (question) => {
    return renderQuestionFunc(question, handleAnswerChange, dataService)
  };

  const BackButton = (
    <PrimaryButton
      text={"Zurück"}
      icon={<ArrowBack color={'primary'}/>}
      variant={"outlined"}
      onButtonClick={onPrevClick}
    />
  );

  const isNewDesign = dataService && dataService.isNewDesign;

  const isStepContentLoading = isNewDesign && questions && questions.some(
    q => q.hasOwnProperty('dataFetched') && !q.dataFetched
  );

  const NextButton = (
    <PrimaryButton
      text={dataService.nextBtnLabel || SAVE_AND_CONTINUE_BTN_LABEL}
      onButtonClick={onNextClick}
      disabled={isStepContentLoading}
    />
  );

  const leftButtons = isNewDesign ? [<><span style={{color: '#0092E5'}}>*</span> Pflichtangaben</>] : [BackButton];

  return (
    <div className={classes.stepContainer}>
      <div className={classes.stepScrollContainer}>
        <div className={clsx(classes.stepContent, 'app-page-container')}>
          {name && (
            <div className={clsx(classes.stepName, custom_classes && custom_classes.stepName)} data-id={`${uid}-name`}>
              <StepName name={name} />
            </div>
          )}
          {required && !isNewDesign && (
            <div className={classes.stepRequired}>
              *Pflichtfeld
            </div>
          )}
          {info_text && (
            <InfoCard uid={uid} info_text={info_text} isNewDesign={isNewDesign} />
          )}
          {help_text && (
            <div className={classes.stepHelpText} data-id={`${uid}-help`}>
              {help_text}
            </div>
          )}
          <ExtraTexts extra_texts={extra_texts} />
          {StepContentComponent && (
            <StepContentComponent
              questions={questions}
              onAnswerChange={handleAnswerChange}
              dataService={dataService}
              onGoToStepClick={onGoToStepClick}
            />
          )}
          {!StepContentComponent && questions && (
            <Grid container className={classes.questionsContent} spacing={2} justify={isNewDesign && !leftAligned && 'center'}>
              {questions.map(renderQuestion)}
            </Grid>
          )}
        </div>
        <div className={classes.scrollFix} />
      </div>

      <StepFooter
        leftItems={!isFirst && leftButtons}
        rightItems={[...extraRightButtons, NextButton]}
      />
    </div>
  );
};

DynamicStep.defaultProps = {
  extraRightButtons: [],
  extra_texts: [],
};

export default withStyles(styles)(DynamicStep);
